import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { Category } from '../types/database'

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchCategories = async () => {
    try {
      setLoading(true)
      setError(null)
      
      console.log('Fetching categories...')

      // Test basic connection first
      const { data: testData, error: testError } = await supabase
        .from('categories')
        .select('count')
        .limit(1)
        
      if (testError) {
        console.error('Database connection test failed:', testError)
        throw new Error(`Database connection failed: ${testError.message}`)
      }
      
      console.log('Database connection successful, fetching categories...')

      // Fetch categories with car count
      const { data: categoriesData, error: categoriesError } = await supabase
        .from('categories')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true })

      if (categoriesError) {
        console.error('Categories fetch error:', categoriesError)
        throw categoriesError
      }

      console.log('Categories fetched:', categoriesData?.length || 0)

      // Get car count for each category
      const categoriesWithCount = await Promise.all(
        (categoriesData || []).map(async (category) => {
          try {
            const { count } = await supabase
              .from('cars')
              .select('*', { count: 'exact', head: true })
              .eq('category_id', category.id)
              .eq('availability', true)

            return {
              ...category,
              car_count: count || 0
            }
          } catch (carCountError) {
            console.warn(`Failed to get car count for category ${category.name}:`, carCountError)
            return {
              ...category,
              car_count: 0
            }
          }
        })
      )

      console.log('Categories with count:', categoriesWithCount.length)
      setCategories(categoriesWithCount)
    } catch (err) {
      console.error('Error fetching categories:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch categories')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories
  }
} 